import type { ReactElement } from 'react';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { FiMaximize } from 'react-icons/fi';

import { Box, Button } from '@highlight-cp/core-ui';

import AssetGalleryModal from './asset-gallery-modal';
import type { AssetGalleryProps } from './types';

const AssetGallery = ({ assets, initialAssetId }: AssetGalleryProps): ReactElement => {
  const { t } = useTranslation();
  const [isOpen, { open, close }] = useDisclosure(false);

  if (!assets.length) return <></>;

  return (
    <>
      <Box pos="relative">
        <Button leftSection={<FiMaximize size={16} />} onClick={open} variant="subtle">
          {t('View full size {{noun}}', {
            noun: assets?.length > 1 ? 'images' : 'image',
          })}
        </Button>
      </Box>

      <AssetGalleryModal
        assets={assets}
        initialAssetId={initialAssetId}
        opened={isOpen}
        onClose={close}
      />
    </>
  );
};

export default AssetGallery;
